namespace B2B.Landing {
    import Transition = B2B.UI.Transition;
    import ClickEvent = JQuery.ClickEvent;

    export class EquipmentSetSection {
        public static Instance: EquipmentSetSection;
        private _element: HTMLElement;
        private _toggleViewButton: HTMLElement;
        private _popup: B2B.UI.Popup;
        private _hiddenContent: HTMLElement;
        private readonly _hiddenContentHeight: number;

        constructor(element: HTMLElement) {
            if (EquipmentSetSection.Instance) {
                throw new Error("Use EquipmentSetSection.Instance");
            }

            EquipmentSetSection.Instance = this;

            this._element = element;
            this._toggleViewButton = this._element.querySelector(".js-equipment-set-toggle-view");
            if(this._toggleViewButton) {
                this._toggleViewButton.addEventListener("click", this.onToggleViewClick.bind(this));
            }

            this._hiddenContent = this._element.querySelector(".js-equipment-set-hidden-content");
            if(this._hiddenContent) {
                this._hiddenContentHeight = $(this._hiddenContent).outerHeight(true);
                this.toggleView(true);
            }

            this._element.querySelectorAll(".js-equipment-set-item")
                .forEach(item => {
                    item.addEventListener("click", this.showItemPopup.bind(this, item));
                });

            this._popup = new B2B.UI.Popup();
            this._popup.element.classList.add("b-popup-equipment-set");
        }

        private showItemPopup(item: HTMLElement, e: MouseEvent){

            let popupContentElement = <HTMLElement>item.querySelector(".js-equipment-set-popup-content");

            if(popupContentElement) {
                let copy = <HTMLElement>popupContentElement.cloneNode(true);
                copy.style.display = "";
                this._popup.setContent(copy);
                this._popup.show();

                setTimeout(() => {
                    $(this._popup.element).find('img.js-equipment-set-lazy').lazyload({
                        effect: "fadeIn"
                    });
                }, 200);

                let submitButton = this._popup.element.querySelector(".btn");
                submitButton.addEventListener("click", this.onSubmitButtonClick.bind(this));

                let firstPhotoLink: HTMLAnchorElement = undefined;
                let firstPhotoImage : HTMLImageElement = undefined;
                this._popup.element.querySelectorAll(".js-equipment-set-detail-photos a").forEach((item, index) => {
                    if (index == 0) {
                        firstPhotoLink = <HTMLAnchorElement>item;
                        firstPhotoImage = item.querySelector("img");
                        return;
                    }

                    item.addEventListener("click", (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        let imgHref = item.getAttribute('href');
                        firstPhotoLink.href = imgHref;
                        firstPhotoImage.src = imgHref;
                        return false;
                    });
                });
            }
        }

        private onToggleViewClick(e: MouseEvent){
            this.toggleView();
        }

        private get isOpened(): boolean{
            return !this._hiddenContent || !this._hiddenContent.classList.contains("equipment-set--hidden");
        }

        private toggleView(hide: boolean = false){
            let instance = this;
            if(this.isOpened || hide){
                $(this._hiddenContent).animate({ height: 0, opacity: 0 }, 100, function (){
                    instance._hiddenContent.classList.add("equipment-set--hidden");
                });
                this._toggleViewButton.innerText = "Еще комплекты";
            }
            else {
                instance._hiddenContent.classList.remove("equipment-set--hidden");
                $(this._hiddenContent).animate({ height: this._hiddenContentHeight, opacity: 1 }, 300, function (){

                });
                this._toggleViewButton.innerText = "Скрыть";
            }
        }

        private onSubmitButtonClick(e: ClickEvent) {
            let options = $(e.currentTarget).data();
            let popup = new B2B.UI.PricePopup({
                title: options['title'],
                dsc: options['dsc'],
                btn: options['btn'],
                theme: options['theme'],
                noEmail: true,
                goalId: options['goalid']
            });
            popup.show().then((data : UI.IPopupResult) => {
                if(data.action == "ok"){
                    window.location.href = "https://sportres.ru/download/";
                }
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    let element = <HTMLElement>document.querySelector('#equipment-set-section');
    if (element) {
        new B2B.Landing.EquipmentSetSection(element);
    }
});